import React from 'react';
import PropTypes from 'prop-types';
import {CustomerNotification} from '../CustomerNotification/CustomerNotification';
import {ApolloProvider} from '@apollo/client';
import {createApolloClient} from './utils/ApolloClientUtil';
import Cookies from 'js-cookie';
import {MOBILE, DESKTOP, defaultDuaId, siteIds} from './NotificationConfig';
function Notification({
    locale,
    isMobile,
    siteName,
    notificationLocation,
    funnelLocation,
}) {
    const duaId = Cookies.get('hav') || defaultDuaId;
    const client = createApolloClient(funnelLocation, duaId);
    const deviceType = isMobile ? MOBILE : DESKTOP;
    const siteId = siteIds[siteName];
    return (
        <ApolloProvider client={client}>
            <CustomerNotification
                locale={locale}
                deviceType={deviceType}
                duaid={duaId}
                notificationLocation={notificationLocation}
                funnelLocation={funnelLocation}
                siteId={siteId}
            />
        </ApolloProvider>
    );
}
Notification.propTypes = {
    locale: PropTypes.string,
    isMobile: PropTypes.bool,
    notificationLocation: PropTypes.string,
    funnelLocation: PropTypes.string,
};

Notification.defaultProps = {
    locale: 'en-US',
    siteName: 'vrbo',
    isMobile: true,
    notificationLocation: 'PRE_HEADER',
    funnelLocation: 'SEARCH_RESULTS',
};

export default Notification;
